export { default } from "./MultipleChoiceQuestionCard"